import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

import "@fontsource/inter"

import './init/amplify';
import './init/app-metadata';
import './init/indexed-db';
import './init/i18n';
import './init/cloudwatch-rum';
import './init/offline-check';
import './features/sign-in-profiles/init/sign-in-profiles';
import './features/applications/init/applications';

import {Provider} from 'react-redux';
import {store} from "./store";


if (!(window as any).__BROWSER_NOT_SUPPORTED__) {
    ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
        .render(
            <React.StrictMode>
                <Provider store={store}>
                    <App/>
                </Provider>
            </React.StrictMode>,
        )
}
